export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  AUTH_EXPIRES_AT: 'auth_expires_at',
  ACTIVE_GAME_SESSION: 'active_game_session',
  PENDING_GAME_FINALIZATION: 'pending_game_finalization',
} as const;
